package se.mittpass.shared.repository

import io.ktor.client.*
import io.ktor.client.call.body
import io.ktor.client.request.*
import se.mittpass.shared.api.*

class MultiWorkplaceRepository(private val httpClient: HttpClient) {
    suspend fun getSummaries(): Result<List<MultiWorkplaceSummaryDto>> = runCatching {
        httpClient.get("multi-workplace/summary").body()
    }
}
